import AndroidSDK from "../../../../src/mdx/sdk/android.mdx";
import * as React from 'react';
export default {
  AndroidSDK,
  React
};